import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import icoback from '../img/ico-back.svg';
import icobackblue from '../img/ico-backblue.svg';
import icosearch from '../img/ico-search.svg';
import icoclose from '../img/ico-close.svg';
import strings from '../strings.js';
import SongCard from '../SongCard';
import heart from '../img/heart.svg';
import noheart from '../img/noheart.svg';
import { SendMessage } from '../App.js';
import useSongSearch from '../useSongSearch';
import homeLogoBg from '../img2026/homeLogoBg.jpg';

const API_URL = "https://www.starboxkod.com/api";

const song1 = {
    "song_num": 110108,
    "song_name": "给我多一点",
    "singer": "SHE",
    "language": "国语",
    "server_id": "C",
    "rel_path": "05\\110108"
}



export function List({ setSelectedSinger, stateVer, lang, statePlaylist, statePlaylistYT, tableNo}) {

    const [pageNumber, setPageNumber] = useState(0);

    const {
        loading,
        error,
        songs,
        hasMore
    } = useSongSearch(statePlaylist, pageNumber)

    const lookup = Object.fromEntries(songs.map(o => [o.song_num, o]));

    lookup["1111"] = {
        "song_num": null,
        "song_name": "YOUTUBE",
        "singer": "YOUTUBE",
        "singer2": null,
        "singer3": null,
        "language": null,
        "server_id": "null",
        "rel_path": "null",
        "audio_track": 1
    };

    const navigate = useNavigate()

    return (<>
    <div className="heatder purple">
        <a onClick={(e) => {e.preventDefault(); console.log(statePlaylist); navigate(-1);}}>
        <img
            src={icoback}
            alt="home"
            
        />
        </a>
        <div className = "headerReplaceText">{lang ? strings.cn.sel : strings.en.sel}</div>
        <div className = "headerEndText" onClick ={(e) => {e.preventDefault(); console.log(statePlaylistYT)}}>{statePlaylist == "" ? [].length : statePlaylist.split(',').length}</div>
    </div>


    <div className="song-container" id="song-container" style={{marginTop: "4rem"}}>
    {!loading && statePlaylist != ""
        ? (
            <>
                {statePlaylist.split(',').map((song_num, index) => {
                    if (lookup[song_num] != null) {
                        if (song_num == "1111") {
                            console.log("신류진");
                            lookup["1111"] = {
                                "song_num": null,
                                "song_name": statePlaylistYT/*.split(',')*/[index].substring(0, 20),
                                "singer": "YOUTUBE",
                                "singer2": null,
                                "singer3": null,
                                "language": null,
                                "server_id": "null",
                                "rel_path": "null",
                                "audio_track": 1
                            }
                        }
                        return <SongCard  setSelectedSinger={setSelectedSinger} List={true} lang={lang} index={index} song={lookup[song_num]} key={index} stateVer={stateVer}/>    
                    }
              
                })}
            </>
        ) :
        (
            <div className="empty">
                <h2>No songs found</h2>
            </div>
        )}
    </div>

    {loading && 'Loading...'}
    {error && 'Error...'}


</>)}
